import { createActions } from 'redux-actions';

import types from 'state/mrCollection/repeated-from/actionTypes';

const { mrCollection } = createActions({
  [types.SET_REPEATED_FROM]: ({ orderId }) => ({ orderId }),
});

export default mrCollection;
